import React from 'react'
import PropTypes from "prop-types"
import CustomModal from './customModal'
import { FaArrowUp, FaArrowDown, FaTable, FaAtom, FaCalculator, FaWater, FaFunnelDollar, FaStickyNote, FaFile } from 'react-icons/fa'
import { IoIosBeaker } from 'react-icons/io'

export default class FormulaButton extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            modal: false
        }
    }

    toggleModal = () => {
        this.setState({ modal: !this.state.modal })
    }

    displayIcon = (label) => {
        switch (label) {
            case 'solidRate':
                return <IoIosBeaker className="icon" />
            case 'propertyTable':
                return <FaTable className="icon" />
            case 'densityCorrection':
                return <FaWater className="icon" />
            case 'unitConverter':
                return <FaCalculator className="icon" />
            case 'atomicMass':
                return <FaAtom className="icon" />
            case 'processYield':
                return <FaFunnelDollar className="icon" />
            case 'breakTime':
                return (
                    <SO3Icon />
                )
            case 'notes':
                return <FaStickyNote className="icon" />
            case 'files':
                return <FaFile className="icon" />
            default:
                return
        }
    }

    render() {
        return (
            <div className="buttons text-center" onClick={this.toggleModal}>
                <ul>
                    <li>{this.displayIcon(this.props.iconName)}</li>
                    <li>{this.props.label}</li>
                </ul>
                {/** MODAL */}
                <CustomModal toggle={this.toggleModal} isOpen={this.state.modal} title={this.props.label}>
                    {/** Injection du composant enfant */}
                    {this.props.children}
                </CustomModal>
            </div>
        )
    }
}

FormulaButton.propTypes = {
    label: PropTypes.string,
    iconName: PropTypes.string
}

// // //
// SO3 Icon
const SO3Icon = () => (
    <div >
        <FaArrowUp className="icon" />
        <span className="small-icon">SO3</span>
        <FaArrowDown className="icon" />
    </div>
)